// SPDX-License-Identifier: AGPL-3.0-or-later
import EmojiPicker from '@app/features/emoji/state/EmojiPicker';
import type {FlatEmoji} from '@app/features/emoji/types/EmojiTypes';

type EmojiPickerIntent =
	| {kind: 'track'; emoji: FlatEmoji}
	| {kind: 'favorite'; emoji: FlatEmoji}
	| {kind: 'category'; category: string};

function getEmojiKey(emoji: FlatEmoji): string {
	if (emoji.id) {
		return `custom:${emoji.guildId}:${emoji.id}`;
	}
	return `unicode:${emoji.uniqueName}`;
}

function dispatchEmojiPickerIntent(intent: EmojiPickerIntent): void {
	switch (intent.kind) {
		case 'track':
			EmojiPicker.trackEmojiUsage(getEmojiKey(intent.emoji));
			return;
		case 'favorite':
			EmojiPicker.toggleFavorite(getEmojiKey(intent.emoji));
			return;
		case 'category':
			EmojiPicker.toggleCategory(intent.category);
			return;
	}
}

export function trackEmojiUsage(emoji: FlatEmoji): void {
	dispatchEmojiPickerIntent({kind: 'track', emoji});
}

export function toggleFavorite(emoji: FlatEmoji): void {
	dispatchEmojiPickerIntent({kind: 'favorite', emoji});
}

export function toggleCategory(category: string): void {
	dispatchEmojiPickerIntent({kind: 'category', category});
}
